export type UniverseWithAuthentication = { tag: string; url: string };

/**
 * Universes that have authentication enabled, with their public URL.
 *
 * The list is read from Sanity at build time and inlined by
 * [next.config.ts](../../next.config.ts) so it is available in the proxy, on
 * the server and in the browser without a request to the CMS.
 */
export function getUniversesWithAuthentication(): UniverseWithAuthentication[] {
  try {
    return JSON.parse(process.env.UNIVERSE_WITH_AUTHENTICATION ?? "[]");
  } catch {
    return [];
  }
}
